const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const getScrollbarWidth = () => {
  let width = 0;
  if (typeof window !== "undefined") {
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    window.scrollbarWidth = width;
  }
  return width;
};
const getMoneyValueUnit = (value) => {
  if (value < 1e6)
    return { value: Math.round(value / 1e3 * 1e3) / 1e3, unit: "K" };
  if (value > 1e9)
    return {
      value: Math.round(value / 1e9 * 1e3) / 1e3,
      unit: "t\u1EF7"
    };
  return { value: Math.round(value / 1e6 * 1e3) / 1e3, unit: "tr" };
};
const getImageUrlFromGoogleUserContent = (imageUrl, imageWidth) => {
  let result = imageUrl;
  if (imageUrl.includes("googleusercontent.com")) {
    if (imageWidth) {
      result = `${imageUrl}=w${imageWidth}`;
    }
  }
  return result;
};

export { canUseDOM, getImageUrlFromGoogleUserContent, getMoneyValueUnit, getScrollbarWidth };
